// @module NVT.MyEventAgenda.MyEventAgendaModule
define('NVT.MyEventAgenda.MyEventAgendaModule.View'
,	[
	'nvt_myeventagenda_myeventagendamodule.tpl'

	,	'NVT.MyEventAgenda.MyEventAgendaModule.SS2Model'

	,	'Backbone'
	, 'ProductDetails.Full.View'
    ]
, function (
	nvt_myeventagenda_myeventagendamodule_tpl

	,	MyEventAgendaModuleSS2Model

	,	Backbone
	, ProductDetailsFullView
)
{
    'use strict';

	// @class NVT.MyEventAgenda.MyEventAgendaModule.View @extends Backbone.View
	return Backbone.View.extend({

		template: nvt_myeventagenda_myeventagendamodule_tpl

	,	initialize: function (options) {
			this.options = options;
			this.container = options.container;
			this.layout = this.container.getComponent('Layout');
			this.pdp = this.container.getComponent('PDP');
			var self = this;
			if (self.pdp) {
				self.pdp.on("afterShowContent", function () {
					var itemDetail = self.pdp.getItemInfo();
				//	alert(itemDetail)
					var model = new MyEventAgendaModuleSS2Model();
					model
					  .fetch({
						async: false,
						data: {
							getsku: itemDetail.item.itemid
						},
					  })
					  .done(function (result) {
						self.message = result.message
						self.render();
					  });
				});
			}
		}


	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return NVT.MyEventAgenda.MyEventAgendaModule.View.Context
	,	getContext: function getContext()
		{
			//@class NVT.MyEventAgenda.MyEventAgendaModule.View.Context
			this.message = this.message
			return {
				message: this.message
			};
		}
	});
});
